











































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import InformeEventBus from '@/pantallas/Informes/partes/InformeEventBus';
import { LoadingService } from '@/services/loadingService';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, Accion } from '@/config/enums';
const { AgGridVue } = require('ag-grid-vue');
import config from '@/config/index';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  CsvExportParams,
  ProcessCellForExportParams,
} from 'ag-grid-community';

@Component({
  components: { 'ag-grid-vue': AgGridVue },
})
export default class EditorConductoresCopiloto extends Vue {
  readonly conductorController: string = 'Conductor';
  @Prop({ default: false }) dialog: boolean;
  @Prop({ default: [] }) drivers: any[];
  axiosVehiculo: AxiosVue = new AxiosVue(ServicioProxy.Vehiculo);
  $snotify: any;
  selectedActived: any = '';
  baseListDisabled: any[] = [];
  listDisabled: any[] = [];
  loadingService = new LoadingService();

  localeText: any = {};
  columnDefs: Array<ColDef> = [];
  //Actived
  gridOptionsActived: GridOptions;
  gridApiActived: GridApi;
  columnApiActived: ColumnApi;
  selectedRowsActived: boolean = true;

  //Deactived
  gridOptionsDeactived: GridOptions;
  gridApiDeactived: GridApi;
  columnApiDeactived: ColumnApi;
  selectedRowsDeactived: boolean = true;

  sideBar: any = {};
  baseListActived: any[] = [];
  listActived: any[] = [];

  mounted() {
    // this.driversHandler.map((driver: any, index: any) => {
    //   return (driver.index = index);
    // });
    // this.baseListActived = this.driversHandler;
    // this.baseListDisabled = this.driversHandler;
    // this.generateLists();
  }

  @Watch('drivers')
  async onDriversChanged() {
    this.selectedRowsActived = true;
    this.selectedRowsDeactived = true;
    const driversActived = this.driversCondition(true);
    const driversDeactived = this.driversCondition(false);
    this.gridApiActived.setRowData(driversActived || []);
    this.gridApiDeactived.setRowData(driversDeactived || []);
  }

  @Watch('dialog')
  async onDialogChanged() {
    this.selectedRowsActived = true;
    this.selectedRowsDeactived = true;
    const driversActived = this.driversCondition(true);
    const driversDeactived = this.driversCondition(false);
    this.gridApiActived.setRowData(driversActived || []);
    this.gridApiDeactived.setRowData(driversDeactived || []);
  }

  isExternalFilterPresent(): boolean {
    return true;
  }

  doesExternalFilterPass(node: RowNode): boolean {
    return true;
  }

  async onGridReadyActived(params: GridReadyEvent) {
    this.gridApiActived = params.api;
    this.columnApiActived = params.columnApi;
    const drivers = this.driversCondition(true);
    this.gridApiActived.setRowData(drivers || []);
  }

  async onGridReadyDeactived(params: GridReadyEvent) {
    this.gridApiDeactived = params.api;
    this.columnApiDeactived = params.columnApi;
    const drivers = this.driversCondition(false);
    this.gridApiDeactived.setRowData(drivers || []);
  }

  driversCondition(state: boolean) {
    return this.drivers.filter((driver: any) => driver.estadoCopiloto == state);
  }

  closeDialog() {
    InformeEventBus.$emit('closeDialog');
  }

  searchActiveDrivers(input: string) {
    this.gridApiActived.setQuickFilter(input);
  }
  searchDeactiveDrivers(input: string) {
    this.gridApiDeactived.setQuickFilter(input);
  }

  async deactivateDrivers() {
    const drivers = this.gridApiActived.getSelectedRows();
    InformeEventBus.$emit('deactivateDrivers', drivers);
  }

  async activateDrivers() {
    const drivers = this.gridApiDeactived.getSelectedRows();
    InformeEventBus.$emit('activateDrivers', drivers);
  }

  onSelectionRowActived(event: any) {
    const drivers: any[] = this.gridApiActived.getSelectedRows();
    this.selectedRowsActived = drivers.length == 0 ? true : false;
  }
  onSelectionRowDeactived(event: any) {
    const drivers: any[] = this.gridApiDeactived.getSelectedRows();
    this.selectedRowsDeactived = drivers.length == 0 ? true : false;
  }

  constructor() {
    super();
    this.localeText = config.agGridTextos;
    this.sideBar = config.agGridDefaultConfig;

    this.columnDefs = [
      {
        headerName: '',
        width: 70,
        minWidth: 70,
        pinned: 'left',
        autoHeight: true,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        suppressMenu: true,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        autoHeight: true,
        sortable: true,
        resizable: true,
        width: 250,
        minWidth: 250,
        lockPinned: true,
      },
    ];

    this.gridOptionsActived = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5, //Solución Paginación
      cacheBlockSize: 10000, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      onGridReady: this.onGridReadyActived,
      columnDefs: this.columnDefs,
      suppressCopyRowsToClipboard: true,
      onSelectionChanged: this.onSelectionRowActived,
      //onRowSelected: this.onSelectionRow,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      blockLoadDebounceMillis: 350,
      // onDragStopped: this.onDragStoppedEvent,
      // onColumnPinned: this.onColumnPinnedEvent,
      columnTypes: {},
      suppressCsvExport: true,
      suppressExcelExport: true,
    };

    this.gridOptionsDeactived = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5, //Solución Paginación
      cacheBlockSize: 10000, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      onGridReady: this.onGridReadyDeactived,
      columnDefs: this.columnDefs,
      suppressCopyRowsToClipboard: true,
      onSelectionChanged: this.onSelectionRowDeactived,
      // onRowSelected: this.onSelectionRow,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      blockLoadDebounceMillis: 350,
      // onDragStopped: this.onDragStoppedEvent,
      // onColumnPinned: this.onColumnPinnedEvent,
      columnTypes: {},
      suppressCsvExport: true,
      suppressExcelExport: true,
    };
  }
}
